<template>
  <v-container text-xs-center>
    <div class="elevation-5">
      <!-- Container for tabs and buttons -->
      <div class="tabs-container">
        <!-- Centered Tabs -->
        <v-tabs
          v-model="mainTab"
          dark
          background-color="light-blue darken-4"
          show-arrows
          @change="updateRouter"
          class="centered-tabs"
        >
          <v-tab key="dataTable">Athlete</v-tab>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-tab key="kanban">Enrollment Board(Beta)</v-tab>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-tab key="pivotTable">Analytics</v-tab>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-tab key="athleteranks">Ranks</v-tab>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-tab key="athleteperformance">Performance</v-tab>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-tab key="athleteattendance">Attendance</v-tab>
        </v-tabs>

        <!-- Right-aligned buttons (only for admin) -->
        <div class="admin-buttons" v-if="isAdmin()">
          <!-- Search Input -->
          <v-text-field
            v-if="searchVisible"
            v-model="search"
            label="Search Athlete"
            single-line
            hide-details
            filled
            rounded
            dense
            style="max-width: 130px"
            class="white-search"
          >
          </v-text-field>
          <!-- Expandable Search Icon -->
          <v-icon
            color="primary"
            @click="
              searchVisible = !searchVisible;
              search = '';
            "
            style="cursor: pointer"
          >
            search
          </v-icon>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <!-- ✅ ADD: Urgent filter quick toggle -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="urgentFilter ? 'error' : 'primary'"
                @click="urgentFilter = !urgentFilter; updateRouter();"
                style="cursor: pointer"
                v-bind="attrs"
                v-on="on"
              >
                {{ urgentFilter ? 'priority_high' : 'low_priority' }}
              </v-icon>
            </template>
            <span>{{ urgentFilter ? 'Show all athletes' : 'Show only urgent items' }}</span>
          </v-tooltip>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <!-- ✅ ADD: Urgent filter in the settings dialog -->
          <v-dialog
            v-model="dialogFilter"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                tune
              </v-icon>
            </template>

            <v-card>
              <v-card-text>
                <span class="headline">Athlete's Settings</span>
                
                <!-- ✅ ADD: Urgent Priority Filter Section -->
                <v-divider style="margin: 12px"></v-divider>
                <div class="d-flex align-center mb-4">
                  <v-switch
                    v-model="urgentFilter"
                    label="Show only urgent items"
                    color="error"
                    hide-details
                    class="mt-0"
                    @change="updateRouter"
                  />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="error" small class="ml-2" v-bind="attrs" v-on="on">
                        priority_high
                      </v-icon>
                    </template>
                    <span>Applied >3 days, Approved >7 days without tryout, or Past tryout >7 days</span>
                  </v-tooltip>
                </div>
                
                <!-- Existing filters -->
                <v-flex xs12>
                  <EventCatalogSelect
                    v-model="selectedEvent"
                    :multiple="true"
                    eventType="term"
                    @input="updateRouter"
                  />
                </v-flex>

                <v-divider style="margin: 8px"></v-divider>
                <v-flex xs12>
                  <v-select
                    v-model="status_selected"
                    :items="statusOptions"
                    v-if="isAdmin()"
                    @change="handleSelection"
                    :menu-props="{ maxHeight: '400' }"
                    label="Status"
                    multiple
                    dark
                    outlined
                    dense
                    hide-details
                    clearable
                    class="light-blue darken-4 select_tab_bar"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item-group>
                        <v-list-item @click="selectAll">
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="selectNone">
                          <v-list-item-content>
                            <v-list-item-title>Select None</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                      <v-divider></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-divider style="margin: 8px"></v-divider>
                <v-flex xs12>
                  <catValueDropDown
                    :outlined="true"
                    v-model="participationDaysFilter"
                    label="Participation Days"
                    catName="WEEKDAYS"
                    :multiList="true"
                  />
                </v-flex>
                <v-divider style="margin: 12px"></v-divider>
                <span class="headline">System Settings</span>
                <v-divider style="margin: 8px"></v-divider>
                <v-icon
                  :color="tableMobile == 0 ? 'grey' : 'primary'"
                  small
                  class="mr-2"
                  @click="tableMobile = tableMobile == 0 ? 600 : 0"
                >
                  display_settings
                </v-icon>
                <span>{{ "Mobile Display" }} </span>
                <v-divider style="margin: 12px"></v-divider>
              </v-card-text>

              <v-card-actions>
                <v-btn color="primary" @click="dialogFilter = false"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <v-dialog
            v-model="dialog"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                person_add_alt_1
              </v-icon>
            </template>
          </v-dialog>
        </div>
      </div>
      <!-- Tab Content -->
      <v-tabs-items v-model="mainTab" touchless>
        <!-- Athlete's Tab -->
        <v-tab-item key="dataTable">
          <!-- Athlete's Tab Content -->
          <v-tabs
            v-model="tab"
            color="white"
            dark
            background-color="light-blue darken-4"
            show-arrows
            fixed-tabs
          >
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab
              v-for="item in groupListFiltered"
              :key="item.node.teamId"
              :href="'#' + `${item.node.teamName}`"
              @click="updateRouter()"
            >
              {{ getTabName(item) }}
            </v-tab>
            <v-tabs-items v-if="mainTab === 0" v-model="tab" touchless>
              <v-tab-item
                v-for="subitem in groupListFiltered"
                :key="subitem.node.teamId"
                :value="subitem.node.teamName"
              >
                <v-data-table
                  :mobile-breakpoint="tableMobile"
                  :headers="headers"
                  :items="getCurrentAthletes(subitem)"
                  :search="search"
                  :custom-filter="customFilter"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  show-group-by
                  :loading="loadingTable"
                  loading-text="Loading, please wait..."
                  background-color="primary"
                  :sort-by="'updateDate'"
                  :sort-desc="false"
                  :item-class="getItemClass"
                  show-group-by
                >
                  <template v-slot:[`item.person.fullName`]="{ item }">
                    <div
                      class="cursor-pointer d-inline-flex align-center text-blue font-weight-medium"
                      @click="
                        openAthleteTab($route.params.club, item.person.personId)
                      "
                      style="gap: 8px"
                    >
                      {{ item.person.fullName }}
                      <v-icon x-small>open_in_new</v-icon>
                    </div>
                  </template>
                  <!-- filepath: c:\REPOs\OLYMPIAN_UI\src\components\views\club\AthleteList.vue -->
                  <template v-slot:[`item.guardianOccupations`]="{ item }">
                    <v-tooltip bottom max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <div 
                          v-bind="attrs" 
                          v-on="on" 
                          class="text-truncate guardian-occupations-cell" 
                          style="max-width: 180px; cursor: pointer;"
                        >
                          {{ getGuardianOccupationsShort(item) }}
                        </div>
                      </template>
                      <!-- Detailed tooltip content -->
                      <div class="guardian-tooltip">
                        <div v-for="(guardian, index) in getGuardianDetails(item)" :key="index" class="mb-2">
                          <div class="font-weight-bold">{{ guardian.title }}</div>
                          <div><strong>Name:</strong> {{ guardian.name }}</div>
                          <div><strong>Occupation:</strong> {{ guardian.occupation }}</div>
                          <div><strong>Email:</strong> {{ guardian.email }}</div>
                          <div><strong>Phone:</strong> {{ guardian.phone }}</div>
                          <div><strong>Relationship:</strong> {{ guardian.relationship }}</div>
                          <div v-if="guardian.occupationDetails" class="text-caption">
                            <strong>Details:</strong> {{ guardian.occupationDetails }}
                          </div>
                          <v-divider v-if="index === 0 && getGuardianDetails(item).length > 1" class="my-2" />
                        </div>
                        <div v-if="getGuardianDetails(item).length === 0" class="text-center text--secondary">
                          No guardian information available
                        </div>
                      </div>
                    </v-tooltip>
                  </template>
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">New Item</v-btn>
                  </template>
                  <template #footer>
                    <v-btn
                      color="primary"
                      v-if="isAdmin()"
                      @click="sendEmail(getCurrentAthletes(subitem))"
                    >
                      Send Group Email
                    </v-btn>
                    <v-btn
                      color="primary"
                      v-if="isAdmin()"
                      @click="copyToClipboard(getCurrentAthletes(subitem))"
                    >
                      Emails to ClipBoard
                    </v-btn>
                    <v-btn
                      color="primary"
                      v-if="isAdmin()"
                      class="no-print"
                      @click="printPage"
                      >Print Table</v-btn
                    >
                  </template>
                  <template v-slot:[`item.person.email`]="{ item }">
                    <div class="truncate-for-print">
                      {{ item.person.email + " | " + item.person.phone }}
                    </div>
                  </template>

                  <!-- <template v-slot:[`item.person.firstName`]="{ item }">
                    <div>
                      {{ item.person.firstName + " " + item.person.lastName }}
                    </div>
                  </template> -->
                  <template v-slot:item.formsSigned="{ item }">
                    <FormsSignedCell :forms-signed="item.formsSigned" />
                  </template>
<!-- In both AthleteList.vue and ClubPersonRel.vue -->
                  <template v-slot:[`item.additionalInfo`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="text-truncate">
                          {{ truncateText(getLatestCommunication(item.additionalInfo) , 30) }}
                        </div>
                      </template>
                         <div class="communication-tooltip">
      {{ getLatestCommunication(item.additionalInfo) }}
    </div>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.tryoutDatetime`]="{ item }">
                    <div>
                      <td class="truncate-for-print">
                        {{ formatDatetime(item.tryoutDatetime) }}
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.updateDate`]="{ item }">
                    <div>
                      <td class="truncate-for-print">
                        {{
                          item.updateDate ? item.updateDate.slice(0, 10) : null
                        }}
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.participationDays`]="{ item }">
                    <ParticipationDaysShort
                      :participation-days="item.participationDays"
                      :workout-schedules="workoutSchedules"
                      :workout-schedule-label="workoutScheduleLabel"
                    />
</template>
                  <!-- v-menu that is triggered by the three dots button -->
                  <template v-slot:[`item.action`]="{ item }">
  <v-menu offset-y open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-btn x-small color="primary" dark v-bind="attrs" v-on="on">
        <v-icon small>more_vert</v-icon>
      </v-btn>
    </template>
    <!-- Menu content (will only be visible when the menu is active) -->
    <v-list>
      <!-- Edit Action -->
      <v-list-item @click="openEditDialog(item)">
        <v-list-item-icon>
          <v-icon>edit</v-icon>
          <!-- Edit icon -->
        </v-list-item-icon>
        <v-list-item-title>Edit</v-list-item-title>
      </v-list-item>
      <v-list-item @click="sendEmail(item)">
        <v-list-item-icon>
          <v-icon>email</v-icon>
          <!-- Edit icon -->
        </v-list-item-icon>
        <v-list-item-title>Email: {{ item.person.email }} </v-list-item-title>
      </v-list-item>
      <v-list-item :href="'tel:' + item.person.phone">
        <v-list-item-icon>
          <v-icon>phone</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Call: {{ item.person.phone }} </v-list-item-title>
      </v-list-item>

      <!-- <v-btn x-small @click="sendEmail(item.node)">
                    {{ item.node.person.email }}
                  </v-btn> -->

      <!-- Delete Action -->
      
                  <v-list-item @click="confirmSubscriptionDelete(item)">
                          <v-list-item-icon>
                            <v-icon>delete</v-icon>
                            <!-- Delete icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Delete Subscription</v-list-item-title>
                        </v-list-item>      
                        <v-list-item @click="athleteDelete(item)">
                          <v-list-item-icon>
                            <v-icon>delete</v-icon>
                            <!-- Delete icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Delete Athlete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>

                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                    Your search for "{{ search }}" found no results.
                  </v-alert>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-tab-item>
        <v-tab-item key="kanban">
          <v-container>
            <AthleteKanban 
              :search="search"
              :selectedEvent="selectedEvent"
              :statusSelected="status_selected"              
            />
          </v-container>
        </v-tab-item>
        <v-tab-item key="pivotTable">
          <v-container>
            <PivotTable
              v-if="mainTab === 2"
              v-show="formattedPivotData.length !== 0"
              :data="formattedPivotData"
              :inProfileName="profileName"
              @profile-selected="handleProfileChange"
              :date-fields="['birthDate', 'createDate']"
              :renderers="pivotRenderers"
            />
          </v-container>
        </v-tab-item>
        <!-- Athlete Ranks -->
        <v-tab-item key="athleteranks">
          <athleteranks />
        </v-tab-item>

        <!-- Athlete Performance -->
        <v-tab-item key="athleteperformance">
          <athleteperformance />
        </v-tab-item>

        <!-- Athlete Attendance -->
        <v-tab-item key="athleteattendance">
          <athleteattendance />
        </v-tab-item>
      </v-tabs-items>
    </div>
    <!-- <v-alert dense type="info" outlined>
      <v-chip class="row-declined">Declined</v-chip> - Athlete declined
      participation

      <v-chip class="row-old">Old</v-chip> - No update 5+ days for
      qualified/tryout, 10+ for confirmed, 31+ for waitlist

      <v-chip class="row-dead">Dead</v-chip> - No response after follow-ups for
      90days+ from create
      <v-chip class="row-active">Active</v-chip>
      - Active Athletes.
    </v-alert> -->

    <!-- Add athlete dialog -->
  <PersonDialog
    v-model="dialog"
    :editedItem="editedItem"
    :editedIndex="editedIndex"
    :groupListFiltered="groupListFiltered"
    :loading="loading"
    @close="close"  
  />
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
        <v-dialog v-model="formsSignedDialog" max-width="800px">
      <v-card>
        <v-card-title>
          Signed Forms
          <v-spacer />
          <!-- {{ selectedFormsSigned }} -->
          <v-btn icon @click="formsSignedDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <FormsSignedViewer :value="selectedFormsSigned" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ✅ UPDATE: Enhanced status legend -->
<v-alert dense type="info" outlined class="mt-4">
  <div class="d-flex flex-wrap align-center">
    <span class="legend-chip row-active ma-1">Active</span>
    <span class="mx-2">Active athletes</span>
    
    <span class="legend-chip row-applied ma-1">Applied</span>
    <span class="mx-2">New applications (>3 days = urgent)</span>
    
    <span class="legend-chip row-approved ma-1">Approved</span>
    <span class="mx-2">Future tryout scheduled OR recent activity</span>
    
    <span class="legend-chip row-warning ma-1">Warning</span>
    <span class="mx-2">Needs tryout scheduling OR recent tryout needs follow-up</span>
    
    <span class="legend-chip row-urgent ma-1">Urgent</span>
    <span class="mx-2">Applied >3 days OR No tryout scheduled >7 days OR Past tryout >7 days</span>
    
    <span class="legend-chip row-declined ma-1">Declined</span>
    <span class="mx-2">Declined participation</span>
    
    <span class="legend-chip row-dead ma-1">Dead</span>
    <span class="mx-2">No response 90+ days</span>
  </div>
</v-alert>
  </v-container>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapGetters, mapActions } from "vuex";
import { nanoid } from "nanoid";
import BaseToolbar from "../../base/BaseToolbar.vue";
import { getCatValues } from "../../../mixins/getCatValues.js";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";
import {
  hasJsonStructure,
  formatDatetime,
  workoutScheduleLabel,
  randomInteger,
  parseParticipationDays,
  getCommunicationCount,
  getLatestCommunication
} from "../../../_helpers/index";
import PivotTable from "../common/Report/PIvotTable.vue";
import AthleteKanban from "./AthleteKanban.vue";
import Communications from "./PersonCommunications.vue";
import ParticipationTerms from "./ClubPersonRel.vue";
import "vue-pivottable/dist/vue-pivottable.css";
import ScrollRenderer from "@vue-pivottable/scroll-renderer";
import PlotlyRenderer from "@vue-pivottable/plotly-renderer";
import athleteperformance from "./AthletePerformance.vue";
import athleteattendance from "./AthleteAttendance.vue";
import athleteranks from "./AthleteRanksResults.vue";
import EventCatalogSelect from "../../shared/selectEventCatalog.vue";
import Person from "./Person.vue";
import JsonDisplay from "./JsonDisplay.vue";
import ParticipationDaysShort from "@/components/shared/ParticipationDaysShort.vue";
import FormsSignedCell from "@/components/shared/FormsSignedCell.vue";
import { openAthleteTab } from "@/_helpers/index.js";
import PersonDialog from "./PersonDialog.vue";

export default {
  components: {
    BaseToolbar,
    catValueDropDown,
    PivotTable,
    athleteperformance,
    athleteattendance,
    athleteranks,
    EventCatalogSelect,
    ParticipationDaysShort,
    FormsSignedCell,
    AthleteKanban,
    PersonDialog,
  },
  mixins: [getCatValues],
  data() {
    return {
      props: {
        profileName: {
          type: String,
          default: function () {
            return "";
          },
        },
      },
      selectedFormsSigned: null,
      formsSignedDialog: false,      
      loadingPivot: true, // Indicates pivot table is loading data
      pivotProps: {
        aggregatorName: "Sum",
        rows: ["eventName"],
        cols: ["Rank"],
        vals: ["score"], // Make sure this exists and is numeric!
        rendererName: "Table",
        rowOrder: "key_a_to_z",
        colOrder: "key_a_to_z",
      },
      // selectedPivotFields: [],
      // pivotFields: [
      //   { text: 'Athlete Name', value: 'Athlete Name' },
      //   { text: 'Athlete Last Name', value: 'Athlete Last Name' },
      //   { text: 'Group', value: 'Group' },
      //   { text: 'Status', value: 'Status' },
      //   { text: 'tryoutDatetime', value: 'tryoutDatetime' },
      //   { text: 'gender', value: 'gender' },
      //   { text: 'additionalInfo', value: 'additionalInfo' },
      //   { text: 'birthDate', value: 'birthDate' },
      //   { text: 'email', value: 'email' },
      //   { text: 'updateDate', value: 'updateDate' },
      //   { text: 'updateSource', value: 'updateSource' },
      //   { text: 'participationDays', value: 'participationDays' },
      //   { text: 'createDate', value: 'createDate' },
      //   { text: 'sourceOfInformation', value: 'sourceOfInformation' },
      //   { text: 'volunteerPreference', value: 'volunteerPreference' },
      //   { text: 'registrationState', value: 'registrationState' },
      //   { text: 'ClubName', value: 'clubName' }

      // ],
      mainTab: 0,
      activeTab: 0,
      tableMobile: 0,
      page: 1,
      itemsPerPage: 150,
      pageCount: 0,
      tab: "All",
      isFormValid: true,
      urgentFilter: false,
      searchVisible: false,
      status: "active",
      search: "",
      selectedEvent: [], // ✅ Make sure this exists
      loadingTable: true,
      dialog: false,
      dialogFilter: false,
      menu: false,
      //TODO Take out this validation rules. We have the same in global const
      name: "Default",
      status_selected: [],
      participationDaysFilter: [],
      dateMenu: false,
      timeMenu: false,
      // status_selected: ['active', 'tryout', 'deposit', 'paid', 'waitlist',''],
      //status_selected: this.catValueListArray('athlete_status').filter(status => status !== "inactive"),
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 10 characters",
      ],
      requiredRule: [(v) => !!v || "Value is required"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+)(\s*;\s*(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+))*$/.test(
            v
          ) || // eslint-disable-line
          "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4}(;\s*\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4})*$/.test(
            v
          ) || "Phone number must be valid",
      ],
      editedIndex: -1,
      editedItem: {
        person: {
          personId: 0,
          firstName: "",
          lastName: "",
          birthDate: "",
          photo: "",
          gender: 0,
          email: "",
          registrationState: false,

          status: 0,
        },
        // language: "",
        // country: 0,
        additionalInfo: "",
        participationDays: "",
        //tryoutDate: new Date().toISOString().split('T')[0],
        //tryoutTime: "18:00",
        tryoutDate: null,
        tryoutTime: null,
        volunteerPreference: 0,
        teamId: 0,
      },
      //TODO Take out this hardcode
      defaultItem: {
        person: {
          personId: 0,
          firstName: "",
          lastName: "",
          birthDate: "",
          photo: "",
          gender: 0,
          email: "",
          registrationState: false,

          status: 0,
        },
        status: 0,
        // language: "",
        // country: 0,
        additionalInfo: "",
        participationDays: "",
        //tryoutDate: new Date().toISOString().split('T')[0],
        //tryoutTime: "18:00",
        tryoutDate: null,
        tryoutTime: null,
        volunteerPreference: 0,
        teamId: 0,
      },
      allowedTimes: ["17:00", "18:00", "19:00"],
    };
  },
  async created() {
    this.allWorkoutSchedules();
    this.setDefaultPivotProps();
    this.editedItem.status = "active";
    
    await this.allClubPersonRel({ clubId: this.$route.params.club })
      .then(() => (this.loadingTable = false))
      .catch((error) => {
        this.loadingTable = false;
      });
      
    await this.allClub({ clubId: this.$route.params.club })
      .then(() => (this.loadingTable = false))
      .catch((error) => {
        this.loadingTable = false;
      });

    if (Object.keys(this.$route.query).length !== 0) {
      const { tab, subTab, status, events, urgent, profileName } = this.$route.query;

      const tabMap = {
        dataTable: 0,
        kanban: 1,
        pivotTable: 2,
        athleteranks: 3,
        athleteperformance: 4,
        athleteattendance: 5,
      };
      this.mainTab = tabMap[tab] !== undefined ? tabMap[tab] : 0;

      if (tab === "dataTable") {
        this.tab = subTab || this.tab;
        
        if (status) {
          this.status_selected = Array.isArray(status) ? status : status.split(',');
        }
        
        if (events) {
          if (events.includes('ALL') || (Array.isArray(events) && events[0] === 'ALL')) {
            this.selectedEvent = [];
          } else {
            this.selectedEvent = Array.isArray(events) 
              ? events.map(Number) 
              : events.split(',').map(Number);
          }
        }
        
        // ✅ ADD: Load urgent filter from URL
        if (urgent === 'true') {
          this.urgentFilter = true;
        }
      }

      if (tab === "pivotTable" && profileName) {
        this.profileName = profileName;
      }
    }

    if (this.status_selected.length == 0) {
      this.status_selectedOnce();
    }
  },
  computed: {
    ...mapGetters([
      "loading",
      "clubPersonRel",
      "groupList",
      "user",
      "hasUser",
      "clubInfo",
      "workoutSchedules",
    ]),
    pivotRenderers() {
      return {
        Table: ScrollRenderer.Table,
        "Table Heatmap": ScrollRenderer["Table Heatmap"],
        "Table Col Heatmap": ScrollRenderer["Table Col Heatmap"],
        "Table Row Heatmap": ScrollRenderer["Table Row Heatmap"],
        "Grouped Column Chart": PlotlyRenderer["Grouped Column Chart"],
        "Stacked Column Chart": PlotlyRenderer["Stacked Column Chart"],
        "Grouped Bar Chart": PlotlyRenderer["Grouped Bar Chart"],
        "Stacked Bar Chart": PlotlyRenderer["Stacked Bar Chart"],
        "Line Chart": PlotlyRenderer["Line Chart"],
        "Dot Chart": PlotlyRenderer["Dot Chart"],
        "Area Chart": PlotlyRenderer["Area Chart"],
        "Scatter Chart": PlotlyRenderer["Scatter Chart"],
        "Multiple Pie Chart": PlotlyRenderer["Multiple Pie Chart"],
      };
    },
formattedPivotData() {
  if (!this.clubPersonRel || !this.clubPersonRel.length) {
    return [];
  }

  return this.clubPersonRel.map((item) => ({
    "Athlete Name": item.person && item.person.firstName && item.person.lastName
      ? `${item.person.firstName} ${item.person.lastName}`
      : "N/A",
    "Group": item.group && item.group.teamName ? item.group.teamName : "NO_DATA",
    "Status": item.status || "NO_DATA",
    "tryoutDatetime": item.tryoutDatetime || "NO_DATA",
    "gender": (item.person && item.person.gender) || "NO_DATA/A",
    "birthDate": (item.person && item.person.birthDate) || "NO_DATA",
    "email": (item.person && item.person.email) || "NO_DATA",
    "additionalInfo": item.additionalInfo || "NO_DATA",
    "updateSource": item.updateSource || "NO_DATA",
    "participationDays": item.participationDays || "NO_DATA",
    "createDate": (item.person && item.person.createDate) || "NO_DATA",
    "sourceOfInformation": (item.person && item.person.sourceOfInformation) || "NO_DATA",
    "volunteerPreference": item.volunteerPreference || "NO_DATA",
    "registrationState": (item.person && item.person.registrationState) || "NO_DATA",
    "clubName": (item.club && item.club.clubName) || "NO_DATA",
    "personId": (item.person && item.person.personId) || "NO_DATA",
    "phone": (item.person && item.person.phone) || "NO_DATA",
    "homeaddress": (item.person && item.person.occupation) || "NO_DATA",
    "postalcode": (item.person && item.person.postalCode) || "NO_DATA",
    "occupation": (item.person && item.person.occupation) || "NO_DATA",
    "formsSigned": item.formsSigned || "NO_DATA",
  }));
},
    formTitle() {
      return this.editedIndex === -1
        ? "New Person"
        : "Edit " +
            this.editedItem.person.firstName +
            " " +
            this.editedItem.person.lastName;
    },
    clubInfoNew() {
      return this.clubInfo.edges.filter(
        (item) => item.node.clubId == this.$route.params.club
      );
    },
    statusOptions() {
      return [...this.catValueListArray("athlete_status")];
    },
    groupListFiltered() {
      //console.log(this.groupList);
      if (this.groupList) {
        return this.groupList
          .filter(
            (item) =>
              item &&
              (this.isAdmin() ||
                (item.node.teamName.toLowerCase() != "inactive" &&
                  //( item.node.teamName.toLowerCase() != "all" || ( this.status_selected == "qualified" && item.node.teamName.toLowerCase() === "all")) &&
                  ((item.node.teamName.toLowerCase() === "all" &&
                    (this.status_selected == "tryout" ||
                      this.status_selected == "qualified")) ||
                    (item.node.teamName.toLowerCase() != "all" &&
                      !(
                        this.status_selected == "tryout" ||
                        this.status_selected == "qualified"
                      )))))
            // &&  item.node.teamName.toLowerCase() != "tryout"
          )
          .sort((a, b) => a.node.orderOnUi - b.node.orderOnUi);
      } else {
        return [];
      }
    }, // contains only Alex and James
    // Dynamic header to hide sensetive fields:
    headers() {
      let headers = [
        {
          text: "Athlete Name",
          align: "left",
          sortable: true,
          value: "person.fullName",
        },
      ];

      if (this.isAdmin()) {
        headers.unshift({ text: "Actions", value: "action", sortable: false });

        //        headers.push({ text: "Team", value: "node.team.teamName" });
        //
        headers.push({ text: "Gender", value: "person.gender" });
        headers.push({ text: "Birth Date", value: "person.birthDate" });
        headers.push({ text: "Group", value: "group.teamName" });
        headers.push({ text: "Event Name", value: "event.name" });
        headers.push({ text: "Tryout Date", value: "tryoutDatetime" });
        //headers.push({ text: "ContactInfo", value: "person.email",hidden: true  });
        headers.push({ text: "Communications", value: "additionalInfo" });
        //        headers.push({ text: "Team", value: "node.team.teamName" });
        //        headers.push({ text: "Status", value: "node.status" });
        
        headers.push({ text: "Status", value: "status" });
        headers.push({
          text: "Registration State",
          value: "person.registrationState",
        });
        //        headers.push({ text: "Phone", value: "node.phone" });
        headers.push({ text: "Create Date", value: "person.createDate" });
        headers.push({ text: "Update Date", value: "updateDate" });
        headers.push({ text: "Forms", value: "formsSigned" });
        headers.push({
          text: "Participation Days",
          value: "participationDays",
        });

        headers.push({
          text: "Lead From",
          value: "person.sourceOfInformation",
        });
        //  headers.push({ text: "Status", value: "node.status" });
        headers.push({ text: "Volunteer Pref", value: "volunteerPreference" });
        headers.push({ text: "Guardian Occupations", value: "guardianOccupations", sortable: false });
        // headers.push({ text: "Update Source", value: "updateSource" });
      }

      return headers;
    },
  },

  watch: {
    dialog(val) {
      //console.log(this.groupList);
      if (this.editedIndex === -1) {
        this.editedItem.teamId = this.tab
          ? this.groupList.filter((item) => item.node.teamName == this.tab)[0]
              .node.teamId
          : "";
      }
      val || this.close();
    },
    // selectedPivotFields(newVal) {
    //   console.log('Selected Pivot Fields:', newVal);
    // },
    tab(newVal) {
      if (this.mainTab === 0) {
        // Only update for dataTable tab
        this.updateRouter();
      }
    },
    clubPersonRel: {
      handler(newVal) {
        this.loadingPivot = !(
          newVal &&
          newVal.edges &&
          newVal.edges.length > 0
        );
      },
      immediate: true, // Run this when the component loads
      deep: true, // Ensure it watches deeply for changes
    },

  },

  methods: {
    ...mapActions([
      "clubPersonRelDelete",
      "allWorkoutSchedules",
      "addUpdateAthlete",
      "DeleteAthlete",
      "allClubPersonRel",
      "allClub",
    ]),
      getCommunicationCount,
  getLatestCommunication,   
    parseParticipationDays,
    workoutScheduleLabel,
    openAthleteTab,
    formatDatetime,
    
  // ✅ ADD: Missing isAthleteUrgent method
getGuardianOccupationsShort(item) {
  try {
    if (!item || !item.person || !item.person.otherInfo) {
      return 'No info';
    }
    
    let data = item.person.otherInfo;
    
    // Handle double-encoded JSON
    while (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (parseError) {
        break;
      }
    }
    
    if (typeof data !== 'object' || data === null) {
      return 'No info';
    }
    
    const occupations = [];
    
    // ✅ CHANGE: Use occupationDetails if not empty, otherwise occupation
    if (data.guardian1 && (data.guardian1.guardianOccupation || data.guardian1.occupationDetails)) {
      const occupation = (data.guardian1.occupationDetails && data.guardian1.occupationDetails.trim()) 
        ? data.guardian1.occupationDetails 
        : data.guardian1.guardianOccupation;
      if (occupation) {
        occupations.push(occupation);
      }
    }
    
    if (data.guardian2 && (data.guardian2.guardianOccupation || data.guardian2.occupationDetails)) {
      const occupation = (data.guardian2.occupationDetails && data.guardian2.occupationDetails.trim()) 
        ? data.guardian2.occupationDetails 
        : data.guardian2.guardianOccupation;
      if (occupation) {
        occupations.push(occupation);
      }
    }
    
    return occupations.length > 0 ? occupations.join('\n') : 'No occupations';
  } catch (error) {
    return 'Error';
  }
},
  
  // ✅ NEW: Detailed guardian information for tooltip
  getGuardianDetails(item) {
    try {
      if (!item || !item.person || !item.person.otherInfo) {
        return [];
      }
      
      let data = item.person.otherInfo;
      
      // Handle double-encoded JSON
      while (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (parseError) {
          break;
        }
      }
      
      if (typeof data !== 'object' || data === null) {
        return [];
      }
      
      const guardians = [];
      
      // Guardian 1
      if (data.guardian1) {
        const g1 = data.guardian1;
        guardians.push({
          title: 'Guardian 1',
          name: `${g1.guardianName || ''} ${g1.guardianLastname || ''}`.trim() || 'Not provided',
          occupation: g1.guardianOccupation || 'Not specified',
          email: g1.guardianEmail || 'Not provided',
          phone: g1.guardianPhone || 'Not provided',
          relationship: g1.guardianRelationship || 'Not specified',
          occupationDetails: g1.occupationDetails || '',
          shareOccupation: g1.shareOccupation || false
        });
      }
      
      // Guardian 2
      if (data.guardian2) {
        const g2 = data.guardian2;
        guardians.push({
          title: 'Guardian 2',
          name: `${g2.guardianName || ''} ${g2.guardianLastname || ''}`.trim() || 'Not provided',
          occupation: g2.guardianOccupation || 'Not specified',
          email: g2.guardianEmail || 'Not provided',
          phone: g2.guardianPhone || 'Not provided',
          relationship: g2.guardianRelationship || 'Not specified',
          occupationDetails: g2.occupationDetails || '',
          shareOccupation: g2.shareOccupation || false
        });
      }
      
      return guardians;
    } catch (error) {
      return [];
    }
  },
  
  // ✅ KEEP: Original method for backwards compatibility (if needed elsewhere)
  getGuardianOccupations(item) {
    try {
      if (!item || !item.person || !item.person.otherInfo) {
        return 'No info';
      }
      
      let data = item.person.otherInfo;
      
      while (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (parseError) {
          break;
        }
      }
      
      if (typeof data !== 'object' || data === null) {
        return 'Parsing failed';
      }
      
      const occupations = [];
      
      if (data.guardian1 && data.guardian1.guardianOccupation) {
        const name = data.guardian1.guardianName || 'Guardian 1';
        occupations.push(name + ': ' + data.guardian1.guardianOccupation);
      }
      
      if (data.guardian2 && data.guardian2.guardianOccupation) {
        const name = data.guardian2.guardianName || 'Guardian 2';
        occupations.push(name + ': ' + data.guardian2.guardianOccupation);
      }
      
      return occupations.length > 0 ? occupations.join(' | ') : 'No occupation info';
    } catch (error) {
      return 'Error processing data';
    }
  },
  isAthleteUrgent(item) {
    const now = new Date();
    const updateDate = item.updateDate ? new Date(item.updateDate) : null;
    const createDate = item.person && item.person.createDate ? new Date(item.person.createDate) : null;
    const tryoutDate = item.tryoutDatetime ? new Date(item.tryoutDatetime) : null;
    
    const differenceInDays = updateDate ? (now - updateDate) / (1000 * 60 * 60 * 24) : 0;
    const differenceInDaysFromCreate = createDate ? (now - createDate) / (1000 * 60 * 60 * 24) : 0;
    
    // Applied > 3 days
    if (item.status === "applied" && differenceInDays > 3) {
      return true;
    }
    
    // Approved status urgency logic
    if (item.status === "approved") {
      // No tryout scheduled and > 7 days since approval
      if (!tryoutDate && differenceInDays > 7) {
        return true;
      }
      
      // Past tryout > 7 days ago
      if (tryoutDate && tryoutDate < now) {
        const daysSinceTryout = (now - tryoutDate) / (1000 * 60 * 60 * 24);
        if (daysSinceTryout > 7) {
          return true;
        }
      }
    }
    
    // Dead leads (any status > 90 days old)
    if (
      (item.status === "applied" || item.status === "approved") &&
      differenceInDaysFromCreate > 90
    ) {
      return true;
    }
    
    return false;
  },
    showFormsSigned(formsSigned) {
      if (!formsSigned) return;
      this.selectedFormsSigned = formsSigned;
      this.formsSignedDialog = true;
    },
    confirmSubscriptionDelete(item) {
      console.log("Confirm delete for item:", item);
      if (confirm("Are you sure you want to delete this relationship?")) {
        this.clubPersonRelDelete({ seqNo : item.seqNo })
          .then(() => {
            this.$toast.success("Subscription deleted successfully.");
            this.allClubPersonRel({ clubId: this.$route.params.club });
          })
          .catch((error) => {
            console.error("Error deleting subscription:", error);
            this.$toast.error("Failed to delete subscription.");
          });
      }
    },
    // applySelectedFields() {
    //   console.log('Selected Pivot Fields:', this.selectedPivotFields)
    //   this.dialog = false // Close the dialog
    // },
    customFilter(value, search, item) {
      // Search across both firstName and lastName
      const fullName = (
        item.person.firstName +
        " " +
        item.person.lastName
      ).toLowerCase();
      const email = (item.person.email || "").toLowerCase();
      const phone = (item.person.phone || "").toLowerCase();
      const additionalInfo = (item.additionalInfo || "").toLowerCase();

      search = search.toLowerCase();

      return (
        fullName.includes(search) ||
        email.includes(search) ||
        phone.includes(search) ||
        additionalInfo.includes(search)
      );
    },
    handleProfileChange(profile) {
      this.profileName = profile;
      this.mainTab = 2; // Ensure we're in pivotTable view
      this.$nextTick(() => {
        this.updateRouter();
      });
    },
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    updateRouter() {
      setTimeout(() => {
        const tabMap = [
          "dataTable",
          "kanban",
          "pivotTable",
          "athleteranks",
          "athleteperformance",
          "athleteattendance",
        ];
        const query = {
          tab: tabMap[this.mainTab] || "dataTable",
        };

        if (this.mainTab === 0) {
          // dataTable
          query.subTab = this.tab;
          
          if (this.status_selected.length > 0) {
            query.status = this.status_selected.join(',');
          }
          
          if (this.selectedEvent.length > 0) {
            query.events = this.selectedEvent.join(',');
          }
          
          // ✅ ADD: Include urgent filter in URL
          if (this.urgentFilter) {
            query.urgent = 'true';
          }
        } else if (this.mainTab === 2) {
          // pivotTable
          if (this.profileName) {
            query.profileName = this.profileName;
          }
        }

        this.$router.replace({ query });
      }, 300);
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.tableMobile = 600;
        return true;
      } else {
        return false;
      }
    },
    selectAll() {
      this.status_selected = this.catValueListArray("athlete_status");
      this.updateRouter();
    },
    selectNone() {
      this.status_selected = [];
      this.updateRouter();
    },
    handleSelection() {
      // Remove "Select All" or "Select None" from selection if manually adjusted
      this.status_selected = this.status_selected.filter(
        (item) => !["Select All", "Select None"].includes(item)
      );
      this.updateRouter();
    },
    isValidJSON(value) {
      // Check if value is not null or undefined
      if (value === null || value === undefined) {
        return false;
      }
      try {
        JSON.parse(value);
        return true;
      } catch (e) {
        return false;
      }
    },
    printPage() {
      // Accessing the window object directly
      window.print(); // This triggers the print dialog
    },
    isAdmin() {
      return this.user && this.user.role == "Administrator";
    },
    status_selectedOnce() {
      this.status_selected = this.catValueListArray("athlete_status").filter(
        (status) =>
          !["inactive", "alumni", "complete", "waitlist", "reconnect"].includes(
            status
          )
      );
    },

    getCurrentAthletes(subItem) {
      if (this.clubPersonRel) {
        return this.clubPersonRel
          .map((item) => {
            const hasPerson =
              item &&
              item.person &&
              item.person.firstName &&
              item.person.lastName;
            return {
              ...item,
              person: {
                ...item.person,
                fullName: hasPerson
                  ? item.person.firstName + " " + item.person.lastName
                  : "Unknown",
              },
            };
          })
          .filter((item) => {
            // Team/event/status filter
            const matchesTeamEventStatus =
              (((item.teamId && item.teamId == subItem.node.teamId) ||
                subItem.node.teamName == "ALL") &&
                JSON.stringify(this.status_selected).includes(item.status) &&
                (this.selectedEvent.length === 0 ||
                  this.selectedEvent.includes(item.event.eventId))) ||
              (item.status === "inactive" &&
                item.status === subItem.node.teamName.toLowerCase());

            // Participation days filter
            const matchesParticipationDay =
              this.participationDaysFilter.length < 1 ||
              !item.participationDays ||
              this.participationDaysFilter.some((day) =>
                this.parseParticipationDays(item.participationDays)
                  .map((id) => {
                    const ws = this.workoutSchedules.find(
                      (ws) => ws.seqNo === id
                    );
                    return ws ? ws.dayOfWeek : null;
                  })
                  .includes(day)
              );

            // ✅ ADD: Urgent filter
            const matchesUrgentFilter = !this.urgentFilter || this.isAthleteUrgent(item);

            return matchesTeamEventStatus && matchesParticipationDay && matchesUrgentFilter;
          });
      } else {
        return [];
      }
    },
copyToClipboard(item) {
  let emails = "";
  if (Array.isArray(item)) {
    emails = [...new Set(item.map(user =>
      user.person && user.person.email ? user.person.email : null
    ).filter(Boolean))].join(";"); // Use ; as separator
  } else if (item && item.person && item.person.email) {
    emails = item.person.email;
  }
  if (emails) {
    navigator.clipboard
      .writeText(emails)
      .then(() => {
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      })
      .catch(() => {});
  }
},

    sendEmail(item) {
      let emailBCC = "";
      if (Array.isArray(item)) {
        emailBCC = [...new Set(item.map(user =>
          user.person && user.person.email ? user.person.email : null
        ).filter(Boolean))].join(";");
      } else if (item && item.person && item.person.email) {
        emailBCC = item.person.email;
      }
      var emailSub =
        this.clubInfoNew[0].node.clubName +
        " Club Announcement for group " +
        this.tab;
      var emailBodyUrl =
        "https://portal.sportecos.com/" +
        this.$route.params.club +
        "/club/athlete_list?tab=" +
        this.tab;
      var emailBody =
        " If you got this email, you are part of " +
        this.clubInfoNew[0].node.clubName +
        " Club group " +
        this.tab +
        "\n" +
        "Refer membership under this link " +
        emailBodyUrl;
      var emailTo = "";
      var emailBody = encodeURIComponent(emailBody);
      //window.open(mail + emails);
      location.href =
        "mailto:" +
        emailTo +
        "?bcc=" +
        emailBCC +
        "&subject=" +
        emailSub +
        "&body=" +
        emailBody;
    },
    handleGetClubList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allClubs", {
        clubId: this.$route.params.club,
      });
    },

    getTeamName: function (item) {
      return this.groupList.find((x) => x.node.teamId == item).node.teamName;
    },

    getTabName(el) {
      // console.log("el", el);
      // console.log("clubPersonRel", this.clubPersonRel);
      if (this.clubPersonRel) {
        //        const athleteQuantity = 1;
        const athleteQuantity = this.getCurrentAthletes(el).length;
        return `${el.node.teamName}(${athleteQuantity})`;
      } else {
        return "";
      }
    },

    athleteDelete(athlete) {
      //console.log("athleteDelete", athlete);
      this.loadingTable = true;
      confirm("Are you sure you want to delete this item?") &&
        this.DeleteAthlete({ personId: athlete.person.personId })
          .then(() => {
            this.loadingTable = false;
            this.$toast.error("Athlete has been deleted");
            this.close();
          })
          .catch((error) => {
            //console.error(error);
            this.loadingTable = false;
            this.close();
          });
    },
    dateWithoutTimezone(date) {
      // Get the timezone offset in milliseconds
      //console.log(date);
      //console.log(Object.prototype.toString.call(date));
      const tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds

      // Subtract the timezone offset to get the UTC equivalent of the date
      const withoutTimezone = new Date(date.valueOf() - tzoffset)
        .toISOString() // Convert to ISO string (which is in UTC)
        .slice(0, -1); // Remove the 'Z' (since you don't want the 'Z' for UTC)
      //console.log(withoutTimezone);
      return withoutTimezone; // This will be the date without timezone applied
    },

    openEditDialog(item = {}) {
      this.editedIndex = 1;
      this.editedItem = { ...item, clubId: this.club, role: "Athlete" };
      this.dialog = true;
    },

    getItemClass(item) {
      const now = new Date();
      
      // ✅ FIX: Get dates properly from the item
      const updateDate = item.updateDate ? new Date(item.updateDate) : null;
      const createDate = item.person && item.person.createDate ? new Date(item.person.createDate) : null;
      const tryoutDate = item.tryoutDatetime ? new Date(item.tryoutDatetime) : null;
      
      // ✅ FIX: Calculate days differences
      const differenceInDays = updateDate ? (now - updateDate) / (1000 * 60 * 60 * 24) : 0;
      const differenceInDaysFromCreate = createDate ? (now - createDate) / (1000 * 60 * 60 * 24) : 0;
      
      // ✅ STEP 1: Active status
      if (item.status === "active") {
        return "row-active";
      }
      
      // ✅ NEW: Applied status - needs immediate attention
      if (item.status === "applied") {
        if (differenceInDays > 3) {
          return "row-urgent"; // Red - needs immediate action
        } else {
          return "row-applied"; // Orange - recently applied
        }
      }
      
      // ✅ UPDATED: Approved status - consider future tryout dates
      if (item.status === "approved") {
        // ✅ NEW: If tryout is scheduled in the future, show as green (good to go)
        if (tryoutDate && tryoutDate > now) {
          return "row-approved"; // Green - future tryout scheduled
        }
        
        // ✅ NEW: If no tryout scheduled, use time-based urgency
        if (!tryoutDate) {
          if (differenceInDays > 7) {
            return "row-urgent"; // Red - no tryout scheduled and overdue
          } else if (differenceInDays > 3) {
            return "row-warning"; // Yellow - needs tryout scheduling
          } else {
            return "row-approved"; // Green - recently approved, still time to schedule
          }
        }
        
        // ✅ NEW: If tryout is in the past, check how long ago
        if (tryoutDate && tryoutDate < now) {
          const daysSinceTryout = (now - tryoutDate) / (1000 * 60 * 60 * 24);
          
          if (daysSinceTryout > 7) {
            return "row-urgent"; // Red - tryout was over a week ago, needs follow-up
          } else if (daysSinceTryout > 3) {
            return "row-warning"; // Yellow - recent tryout, needs status update
          } else {
            return "row-approved"; // Green - very recent tryout
          }
        }
      }
      
      // ✅ RESTORE: Declined status
      if (item.status === "declined") {
        return "row-declined";
      }
      
      // ✅ RESTORE: Dead leads logic
      if (
        (item.status === "applied" || item.status === "approved") &&
        differenceInDaysFromCreate > 90
      ) {
        return "row-dead";
      }
      
      // For other statuses, return empty (default styling)
      return "";
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    setDefaultPivotProps() {
      this.pivotProps.aggregatorName = "List Unique Values";
      this.pivotProps.rendererName = "Table";
      this.pivotProps.rowOrder = "key_a_to_z";
      this.pivotProps.colOrder = "key_a_to_z";
      this.pivotProps.vals = [];
      this.pivotProps.cols = [];
      this.pivotProps.rows = [];
    },
  },
  mounted() {
    this.isMobile();
    this.status_selectedOnce();
    // console.log('Headers Data:', this.headers);
    // console.log('Selected Pivot Fields:', this.selectedPivotFields);
    // console.log('Pivot Props:', this.pivotProps);
    // console.log("this.user");
    // console.log(this.user);
    //        this.status_selected = catValueListArray('athlete_status');
  },
};
</script>

<style>
@media print {
  /* More aggressive page margins */
  @page {
    size: auto;
    margin: 5mm 3mm;
    /* Reduced margins (top/bottom 5mm, left/right 3mm) */
  }

  /* Compact body styling */
  body {
    background: white !important;
    color: black !important;
    font-size: 9pt !important;
    /* Slightly smaller font */
    line-height: 1.2 !important;
    /* Tighter line spacing */
    margin: 0 !important;
    padding: 2mm !important;
    /* Minimal padding */
    width: 100% !important;
  }

  /* Table optimization */
  .v-data-table {
    width: 100% !important;
    max-width: 100% !important;
    border-collapse: collapse !important;
    page-break-inside: auto !important;
    table-layout: fixed !important;
    /* Ensures consistent column widths */
  }

  /* Compact cell styling */
  .v-data-table th,
  .v-data-table td {
    border: 1px solid #ddd !important;
    padding: 2px 3px !important;
    /* Minimal padding */
    text-align: left !important;
    font-size: 8.5pt !important;
    /* Smaller font in cells */
    line-height: 1.1 !important;
    word-break: break-word !important;
    /* Prevent text overflow */
  }

  /* Header styling */
  .v-data-table thead th {
    background-color: #f5f5f5 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    font-weight: bold !important;
    font-size: 9pt !important;
  }

  /* Hide everything non-essential */
  .no-print,
  .v-data-footer,
  .v-data-table__progress,
  .v-btn,
  .v-toolbar,
  .v-pagination {
    display: none !important;
  }

  /* Page break control */
  tr {
    page-break-inside: avoid !important;
    page-break-after: auto !important;
  }

  /* Optional: alternate row colors */
  .v-data-table tbody tr:nth-child(odd) td {
    background-color: #f9f9f9 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Force landscape orientation for wide tables */
  @page {
    size: landscape;
  }

  /* Column width optimization */
  .v-data-table {
    transform: scale(0.95) !important;
    transform-origin: 0 0 !important;
  }
}

.row-active {
  background-color: #e8f5e9;
  /* Light green background */
  color: #388e3c;
  /* Dark green text */
}

.row-old {
  background-color: #ffebee;
  /* Light red background */
  color: #b71c1c;
  /* Dark red text */
}

.row-dead {
  background-color: #e0e0e0;
  /* Light gray background */
  color: #757575;
  /* Dark gray text */
}

.row-declined {
  background-color: #fff3e0;
  /* Light amber background */
  color: #ff9800;
  /* Amber text */
}

/* ✅ NEW: Applied status classes */
.row-applied {
  background-color: #fff8e1; /* Light orange */
  color: #f57c00; /* Orange text */
  border-left: 4px solid #ff9800; /* Orange border for attention */
}

/* ✅ NEW: Approved status classes */
.row-approved {
  background-color: #e3f2fd; /* Light blue */
  color: #1976d2; /* Blue text */
  border-left: 4px solid #2196f3; /* Blue border */
}

/* ✅ NEW: Warning class (approved > 3 days) */
.row-warning {
  background-color: #fffde7; /* Light yellow */
  color: #f57f17; /* Dark yellow text */
  border-left: 4px solid #ffeb3b; /* Yellow border */
  animation: pulse-warning 2s infinite; /* ✅ Subtle animation */
}

/* ✅ NEW: Urgent class (applied > 3 days OR approved > 7 days) */
.row-urgent {
  background-color: #ffebee; /* Light red */
  color: #c62828; /* Dark red text */
  border-left: 4px solid #f44336; /* Red border */
  animation: pulse-urgent 1.5s infinite; /* ✅ More noticeable animation */
  font-weight: 500; /* ✅ Slightly bolder text */
}

/* ✅ NEW: Pulse animations for attention */
@keyframes pulse-warning {
  0% { box-shadow: 0 0 0 0 rgba(255, 235, 59, 0.4); }
  70% { box-shadow: 0 0 0 4px rgba(255, 235, 59, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 235, 59, 0); }
}

@keyframes pulse-urgent {
  0% { box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4); }
  70% { box-shadow: 0 0 0 6px rgba(244, 67, 54, 0); }
  100% { box-shadow: 0 0 0 0 rgba(244, 67, 54, 0); }
}
</style>

<style scoped>
.white-search {
  background-color: white !important;
}

.white-search .v-input__control {
  background-color: white !important;
}

.white-search .v-input__slot {
  background-color: white !important;
}

.white-search input {
  color: black !important;
}

.white-search label {
  color: rgba(0, 0, 0, 0.6) !important;
}

.tabs-container {
  position: relative;
  display: flex;
  justify-content: center;
  background-color: light-blue darken-4;
}

.centered-tabs {
  margin: 0 auto;
}

.admin-buttons {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  padding-right: 16px;
  background-color: inherit;
  z-index: 1;
}

/* Ensure the tabs take full width */
.v-tabs {
  width: 100%;
}

/* Adjust the tab slider to account for the buttons */
.v-tabs-slider {
  margin-left: auto;
  margin-right: auto;
}
.compact-tabs {
  width: 100%;
  min-width: 130px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0;
}

.compact-tab {
  min-height: 32px;
  font-size: 11px;
  padding: 6px 10px;
  margin: 2px 0;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  line-height: 1.2;
  transition: background 0.2s ease;
}

.compact-tab:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.compact-tab--active {
  background-color: #1976d2;
  box-shadow: inset 4px 0 0 #ffffff;
}

.v-tabs-slider {
  display: none !important;
}

/* Material Icons */
.material-icons {
  font-size: 16px;
  vertical-align: middle;
}

@media (max-width: 1500px) {
  .tabs-container {
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .admin-buttons {
    position: static !important;
    transform: none !important;
    padding-right: 0 !important;
    margin-top: 8px;
    margin-bottom: 8px;
    justify-content: flex-end;
    width: 100%;
    background: none;
  }
  .centered-tabs {
    margin: 0;
  }

}
  .communication-history {
  max-height: 300px;
  overflow-y: auto;
}

.communication-entry {
  padding: 8px 0;
}

.communication-entry:last-child {
  margin-bottom: 0 !important;
}

.text--secondary {
  color: #666 !important;
}

/* ✅ ADD: CSS for tooltip line breaks */
.communication-tooltip {
  white-space: pre-line; /* This makes \n line breaks work */
  max-width: 400px;
  word-wrap: break-word;
}

/* ✅ ADD: Simple styling for legend chips to look like v-chip */
.legend-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  min-height: 24px;
  white-space: nowrap;
  vertical-align: middle;
}

/* ✅ UPDATE: Guardian occupations cell styling with line break support */
.guardian-occupations-cell {
  border-bottom: 1px dotted #1976d2;
  color: #1976d2;
  font-weight: 500;
  white-space: pre-line !important; /* ✅ IMPORTANT: Force line breaks */
  line-height: 1.4 !important; /* ✅ Better line spacing */
  max-height: none !important; /* ✅ REMOVE height limit */
  overflow: visible !important; /* ✅ Allow content to show */
  word-wrap: break-word; /* ✅ Handle long occupation names */
  padding: 4px 0; /* ✅ Add some vertical padding */
}

.guardian-occupations-cell:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

/* ✅ NEW: Ensure v-data-table doesn't override our styling */
.v-data-table td.guardian-occupations-cell {
  white-space: pre-line !important;
  vertical-align: top !important; /* ✅ Align to top for multi-line content */
  height: auto !important; /* ✅ Allow row to expand */
}
</style>
